import { supabase } from '@/integrations/supabase/client';

/**
 * Deletes Google Calendar events linked to the given schedule_items
 * BEFORE the rows are removed from the DB. Uses `sendUpdates=none`:
 * la sincronización de calendario nunca envía correos a los participantes.
 *
 * Failure is non-blocking: we log to console but do not throw, so that
 * a Calendar API issue never blocks the DB cleanup.
 */
export async function deleteCalendarEventsForScheduleItems(
  filter:
    | { cohortIds: string[] }
    | { refIds: string[]; type?: string | string[] }
    | { scheduleItemIds: string[] }
) {
  try {
    let query = supabase
      .from('cohort_schedule_items')
      .select('id, google_event_id')
      .not('google_event_id', 'is', null);

    if ('cohortIds' in filter) {
      if (filter.cohortIds.length === 0) return;
      query = query.in('cohort_id', filter.cohortIds);
    } else if ('refIds' in filter) {
      if (filter.refIds.length === 0) return;
      query = query.in('ref_id', filter.refIds);
      if (filter.type) {
        query = Array.isArray(filter.type)
          ? query.in('type', filter.type)
          : query.eq('type', filter.type);
      }
    } else {
      if (filter.scheduleItemIds.length === 0) return;
      query = query.in('id', filter.scheduleItemIds);
    }

    const { data, error } = await query;
    if (error) {
      console.warn('[deleteCalendarEventsForScheduleItems] fetch error', error);
      return;
    }
    const ids = (data || []).map((r: any) => r.google_event_id).filter(Boolean);
    if (ids.length === 0) return;
    const { error: invErr } = await supabase.functions.invoke('delete-calendar-events', {
      body: { google_event_ids: ids },
    });
    if (invErr) console.warn('[deleteCalendarEventsForScheduleItems] invoke error', invErr);
  } catch (e) {
    console.warn('[deleteCalendarEventsForScheduleItems] unexpected', e);
  }
}
